<div class="col-lg-12">
    <div id="top-text-title">
        Mission
    </div>
    <div id="text-content">
        The fire in the souls of our team for the creation of innovative and high-tech products is inherited from the great achievements of our country in the technology sector in the past.<br><br>
        The technical economy of our country is proud of its great achievements, creating in the past many different products in the technology industry - automated production lines, robots, computer hardware and much more.<br>
        Our team is proud of the achievements of past generations of thousands of Bulgarian engineering teams that have proven themselves on the world technical scene through their creations.<br><br>
        We believe that where it burned, it will burn again.<br><br>
        Our mission is to do our best to improve and develop the technology sector in Bulgaria, making it again IT and high-tech center of Europe, creating a bridge to the future.
    </div>
</div>